export default __webpack_public_path__ + "static/media/2060.db4ad69b.png";